var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle43543(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 259,
    viewBox: "0 0 234 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.433594 6.64124C0.433594 3.30616 3.13722 0.602539 6.4723 0.602539H227.867C231.401 0.602539 234.18 3.62411 233.885 7.14589L214.852 234.103C214.608 237.014 212.315 239.333 209.407 239.61L7.04482 258.883C3.49959 259.22 0.433594 256.432 0.433594 252.871V6.64124Z",
    fill: "url(#paint0_linear_2514_42878)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4723 1.10254H227.867C231.109 1.10254 233.658 3.87392 233.387 7.1041L214.354 234.061C214.13 236.731 212.027 238.858 209.36 239.112L6.99741 258.385C3.74572 258.695 0.933594 256.137 0.933594 252.871V6.64124C0.933594 3.5823 3.41336 1.10254 6.4723 1.10254Z",
    stroke: "#FFFBFB",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2514_42878",
    x1: 0.433594,
    y1: 130.057,
    x2: 234.434,
    y2: 130.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5BE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle43543);
export default __webpack_public_path__ + "static/media/rectangle-43543.a3df2918f83cec8fc73423c2af343f64.svg";
export { ForwardRef as ReactComponent };